import React, {useEffect, useState} from "react";
import TweetListItem from "./TweetListItem";

const TweetApiClient = () => {
  const [tweets, setTweets] = useState([]);
  // Retrieve the initial set of tweets and put them into State
  const url = 'https://enigmatic-fortress-23182.herokuapp.com/api/tweets';
  useEffect(() =>
          fetch(url)
          .then(response => response.json())
          .then(tweets => setTweets(tweets)), []);

  return(
      <>
        <ul className="list-group">
          {
            tweets.map(tweet =>
                <TweetListItem tweet={tweet}/>
            )
          }
        </ul>
      </>
  )
};
export default TweetApiClient;
